<template>
  <div :class="$style.root">
    <OrganismsLoading v-show="isLoading" />
    <div v-if="!isLoading">
      <section :class="$style.fv_section">
        <PagePartsImageSlideBig :img-list="topImageList" is-top />
      </section>

      <section :class="$style.banner_section">
        <TopImageBanner
          v-for="banner in bannerContents"
          :key="banner.pcImage"
          :class="$style.banner_box"
          :pc-image="banner.pcImage"
          :sp-image="banner.spImage"
          :min-screen-md="minScreenMd"
          :tag="banner.tag"
          :title="banner.title"
          :description="banner.description"
          :link-url="banner.linkUrl"
          :img-alt="banner.imgAlt"
          link-type="fullImage"
          image-rounded
        />
      </section>

      <section :class="$style.popular_products_section">
        <div :class="$style.popular_products_wrapper">
          <TopProductListHeader
            :class="$style.product_list_header"
            title="人気の商品"
            button-text="すべての商品をみる"
            button-link="/products"
          />
          <div v-if="products.popular.length" :class="$style.product_lists">
            <PagePartsProductListItemCarousel :products="products.popular" button-variant="primary" />
          </div>
        </div>
      </section>

      <section :class="$style.category_section">
        <TopProductListHeader
          :class="$style.product_list_header"
          title="カテゴリ"
          button-text="商品一覧へ"
          button-link="/products"
        />
        <div :class="$style.category_list_wrapper">
          <AtomsConsumerLink
            v-for="category in categoryContents"
            :key="category.link"
            :url="category.link"
            :class="$style.category_list"
            @click="trackCategoryClick(category.title)"
          >
            <AtomsConsumerImage :class="$style.img" :src="category.image" :alt="category.title" />
            <p :class="$style.category_name">{{ category.title }}</p>
          </AtomsConsumerLink>
        </div>
      </section>

      <section :class="$style.bedding_section">
        <TopImageBanner
          pc-image="/images/top/section-header/bedding-pc.jpg"
          sp-image="/images/top/section-header/bedding-sp.jpg"
          :min-screen-md="minScreenMd"
          :title="
            minScreenMd
              ? `たった一枚の、ちょうどいい世界。\nBAKUNE Comforter`
              : `たった一枚の、\nちょうどいい世界。\nBAKUNE Comforter`
          "
          :description="
            minScreenMd
              ? `枕やマットレス、パジャマだけじゃ、もったいない。\n掛け布団を見直すことで、あなたの睡眠環境はもっとよくなる。`
              : `枕やマットレス、パジャマだけじゃ、もったいない。\n掛け布団を見直すことで、\nあなたの睡眠環境はもっとよくなる。`
          "
          link-url="/features/comforter_series_lineup"
        />
        <div :class="$style.product_list_wrapper">
          <TopProductListHeader
            :class="$style.product_list_header"
            title="寝具"
            button-text="もっと見る"
            button-link="/night-conditioning/bedding"
          />
          <div v-if="products.bedding.length" :class="$style.product_lists">
            <PagePartsProductListItemCarousel :products="products.bedding" button-variant="primary" />
          </div>
        </div>
      </section>

      <section :class="$style.bakune_section">
        <TopImageBanner
          pc-image="/images/top/section-header/bakune-pc.jpg"
          sp-image="/images/top/section-header/bakune-sp.jpg"
          :min-screen-md="minScreenMd"
          title="着て、寝るだけで疲労回復"
          :description="`さらりとした肌触りとリカバリー効果で、\n睡眠環境をサポートする機能性パジャマ`"
          link-url="/products/bakune-dry-womens-25ss-long-tshirt-set"
        />
        <div :class="$style.product_list_wrapper">
          <TopProductListHeader
            :class="$style.product_list_header"
            title="BAKUNE"
            button-text="もっと見る"
            button-link="/night-conditioning/recovery-wear"
          />
          <div v-if="products.recoveryWear.length" :class="$style.product_lists">
            <PagePartsProductListItemCarousel :products="products.recoveryWear" button-variant="primary" />
          </div>
        </div>
      </section>

      <section :class="$style.comfort_tech_wear_section">
        <TopImageBanner
          pc-image="/images/top/section-header/migaru-pc.jpg"
          sp-image="/images/top/section-header/migaru-sp.jpg"
          :min-screen-md="minScreenMd"
          :title="`あらゆる時間を\nコンディショニングタイムに`"
          :description="
            minScreenMd
              ? `仕事時も、移動時も、リラックスタイムも\n機能性とデザイン性を兼ね備えた機能性ウェア「MIGARU」シリーズ`
              : `仕事時も、移動時も、リラックスタイムも\n機能性とデザイン性を兼ね備えた機能性ウェア\n「MIGARU」シリーズ`
          "
          link-url="/features/comfort-techwear-migaru"
        />
        <div :class="$style.product_list_wrapper">
          <TopProductListHeader
            :class="$style.product_list_header"
            title="アパレル"
            button-text="もっと見る"
            button-link="/day-conditioning/comfort-tech-wear"
          />
          <div v-if="products.comfortTechWear.length" :class="$style.product_lists">
            <PagePartsProductListItemCarousel :products="products.comfortTechWear" button-variant="primary" />
          </div>
        </div>
      </section>

      <section :class="$style.sandal_section">
        <TopImageBanner
          pc-image="/images/top/section-header/sandal-pc.jpg"
          sp-image="/images/top/section-header/sandal-sp.jpg"
          :min-screen-md="minScreenMd"
          :title="`足を空っぽにする\nリカバリーサンダル`"
          :description="`足の負担を軽減する適度なクッション性\n幅広いシーンで足元のサポートを実現`"
          link-url="/products/recoverysandal-slide-25ss"
        />
        <div :class="$style.product_list_wrapper">
          <TopProductListHeader
            :class="$style.product_list_header"
            title="フットウェア"
            button-text="もっと見る"
            button-link="/day-conditioning/sandal"
          />
          <div v-if="products.sandal.length" :class="$style.product_lists">
            <PagePartsProductListItemCarousel :products="products.sandal" button-variant="primary" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs"
import { useCustomMeta } from "~/composables/meta"
import type { PagePartsProductType } from "~/types/product"

definePageMeta({ layout: "default-with-extended-footer" })

const customMeta = useCustomMeta()
const { width: windowWidth } = useWindowSize()
const { trackCategoryClick } = useGtagEvent()
const minScreenMd = computed(() => windowWidth.value >= 768)

const isLoading = useState<boolean>(() => true)
const bannerContents: {
  pcImage: string
  spImage: string
  tag: string
  title: string
  description: string
  linkUrl: string
  imgAlt: string
}[] = [
  // 奇数になったとき用のバナー
  {
    pcImage: `/images/top/banner/fathers-day-pc.png`,
    spImage: `/images/top/banner/fathers-day-sp.png`,
    tag: "",
    title: "",
    description: "",
    linkUrl: "/features/mothers-fathers-day-2025",
    imgAlt: "母の日&父の日ギフト いつでも元気でいてほしいから一年に一度の「ありがとう」",
  },
  // {
  //   pcImage: `/images/top/banner/athlete-imanaga-pc.png`,
  //   spImage: `/images/top/banner/athlete-imanaga-sp.png`,
  //   tag: "",
  //   title: "",
  //   description: "",
  //   linkUrl: "/athletecollection_imanagamodel",
  //   imgAlt: "アスリートコレクション 今永選手がこだわった数量限定のMIGARUが登場 詳しくみる",
  // },
  // {
  //   pcImage: `/images/top/banner/athlete-hirano-pc.png`,
  //   spImage: `/images/top/banner/athlete-hirano-sp.png`,
  //   tag: "",
  //   title: "",
  //   description: "",
  //   linkUrl: "/athletecollection",
  //   imgAlt: "アスリートコレクション 平野選手がこだわった数量限定カラーのBAKUNEが登場 詳しくみる",
  // },
]
const categoryContents = [
  {
    title: "BAKUNE パジャマ\n(リカバリーウェア)",
    image: "/images/top/category/bakune.jpg",
    link: "/night-conditioning/recovery-wear",
  },
  {
    title: "寝具",
    image: "/images/top/category/bedding.jpg",
    link: "/night-conditioning/bedding",
  },
  {
    title: "アパレル",
    image: "/images/top/category/apparel.jpg",
    link: "/day-conditioning/comfort-tech-wear",
  },
  {
    title: "サンダル",
    image: "/images/top/category/sandal.jpg",
    link: "/day-conditioning/sandal",
  },
  {
    title: "インナーウェア",
    image: "/images/top/category/inner-wear.jpg",
    link: "/day-conditioning/inner-wear",
  },
  {
    title: "インソール",
    image: "/images/top/category/insole.jpg",
    link: "/day-conditioning/insole",
  },
  {
    title: "スリープアクセサリー",
    image: "/images/top/category/sleep-accessory.jpg",
    link: "/night-conditioning/sleep-accessory",
  },
  {
    title: "トラベルアクセサリー",
    image: "/images/top/category/travel-accessory.jpg",
    link: "/day-conditioning/travel-accessory",
  },
  {
    title: "入浴剤",
    image: "/images/top/category/bath.jpg",
    link: "/night-conditioning/bath",
  },
]

const topImageList = computed(() => {
  const list = [
    {
      url: "/bakune/cm",
      sp_img_url: "/images/top/kv/slide-1-sp.jpg",
      pc_img_url: "/images/top/kv/slide-1-pc.jpg",
      sp_img_url_caption: "疲労回復は、パジャマから。",
      pc_img_url_caption: "疲労回復は、パジャマから。",
    },
    {
      url: "/features/comforter_series_lineup",
      sp_img_url: "/images/top/kv/comforter-series-lineup-sp.jpg",
      pc_img_url: "/images/top/kv/comforter-series-lineup-pc.jpg",
      sp_img_url_caption: "たった一枚の、ちょうどいい世界。BAKUNE Comforter",
      pc_img_url_caption: "たった一枚の、ちょうどいい世界。BAKUNE Comforter",
    },
    {
      url: "/products/bakune-dry-womens-25ss-long-tshirt-set",
      sp_img_url: "/images/top/kv/bakune-womens-25ss-sp.jpg",
      pc_img_url: "/images/top/kv/bakune-womens-25ss-pc.jpg",
      sp_img_url_caption: "着て、寝るだけで疲労回復",
      pc_img_url_caption: "着て、寝るだけで疲労回復",
    },
    {
      url: "/features/comfort-techwear-migaru",
      sp_img_url: "/images/top/kv/migaru-25ss-sp.jpg",
      pc_img_url: "/images/top/kv/migaru-25ss-pc.jpg",
      sp_img_url_caption: "あらゆる時間をコンディショニングタイムに",
      pc_img_url_caption: "あらゆる時間をコンディショニングタイムに",
    },
    {
      url: "/products/recoverysandal-slide-25ss",
      sp_img_url: "/images/top/kv/sandal-25ss-sp.jpg",
      pc_img_url: "/images/top/kv/sandal-25ss-pc.jpg",
      sp_img_url_caption: "足を空っぽにする冬用リカバリーサンダル",
      pc_img_url_caption: "足を空っぽにする冬用リカバリーサンダル",
    },
    {
      url: "/features/bakune-aroma",
      sp_img_url: "/images/top/kv/bakune-aroma-sp.jpg",
      pc_img_url: "/images/top/kv/bakune-aroma-pc.jpg",
      sp_img_url_caption: "眠りに包まれ、カラダ満ちる私を解放するBAKUNEアロマ",
      pc_img_url_caption: "眠りに包まれ、カラダ満ちる私を解放するBAKUNEアロマ",
    },
    {
      url: "/features/comforter-premium-allseasons",
      sp_img_url: "/images/top/kv/slide-6-sp.jpeg",
      pc_img_url: "/images/top/kv/slide-6-pc.jpeg",
      sp_img_url_caption: "シリーズ史上、最高品質を目指した掛け布団",
      pc_img_url_caption: "シリーズ史上、最高品質を目指した掛け布団",
    },
    {
      url: "/features/futonkaisyu-program",
      sp_img_url: "/images/top/kv/futonkaisyu-program-sp.jpg",
      pc_img_url: "/images/top/kv/futonkaisyu-program-pc.jpg",
      sp_img_url_caption: "羽毛布団リサイクルプログラム",
      pc_img_url_caption: "羽毛布団リサイクルプログラム",
    },
  ]
  // 3/31 21:00より前だったら先頭に表示
  if (dayjs().isBefore("2025-03-31 21:00")) {
    list.unshift({
      url: "/features/newlife2025",
      sp_img_url: "/images/top/kv/new_life_campaign_sp.png",
      pc_img_url: "/images/top/kv/new_life_campaign_pc.png",
      sp_img_url_caption: "新生活応援CAMPAIGN",
      pc_img_url_caption: "新生活応援CAMPAIGN",
    })
  }
  return list
})

const { data } = await useAsyncData("pageFetch", async () => {
  const response = await $fetch(`/api/page/top`)
  // Queryの結果がない場合は404
  if (response.status !== 200)
    throw createError({ statusCode: 404, statusMessage: "Page Not Found TOP", fatal: process.client })
  return { pageOneResponse: response.data }
})

const pageOneResponse = data.value?.pageOneResponse

// TODO: 型修正
const products: {
  popular: PagePartsProductType[]
  recoveryWear: PagePartsProductType[]
  comfortTechWear: PagePartsProductType[]
  bedding: PagePartsProductType[]
  sandal: PagePartsProductType[]
} = {
  popular: (pageOneResponse?.popular_products as PagePartsProductType[]) ?? [],
  recoveryWear: (pageOneResponse?.recovery_wear_products as PagePartsProductType[]) ?? [],
  comfortTechWear: (pageOneResponse?.comfort_tech_wear_products as PagePartsProductType[]) ?? [],
  bedding: (pageOneResponse?.bedding_products as PagePartsProductType[]) ?? [],
  sandal: (pageOneResponse?.sandal_products as PagePartsProductType[]) ?? [],
}

useHead(
  customMeta.fetch({
    description: "TENTIAL ONLINE STORE | TENTIAL公式オンラインストア",
  }),
)

onMounted(() => {
  isLoading.value = false
})
</script>

<style scoped module lang="scss">
.root {
  img {
    width: 100%;
    object-fit: contain;
  }
  .fv_section {
    position: relative;
    overflow: hidden;
  }
  .banner_section {
    @include container-xl;
    margin: 2rem auto;
    display: flex;
    gap: 1rem;
    flex-direction: column;
    @include lg {
      display: grid;
      gap: 1.5rem;
      grid-template-columns: repeat(2, 1fr);
      padding: 0 2rem;

      // bannerContentsが1枚の場合の中央配置スタイル
      &:has(.banner_box:only-child) {
        display: flex;
        justify-content: center;
        align-items: center;

        .banner_box:only-child {
          width: 1200px;
          max-width: 100%;
          aspect-ratio: unset;
        }
      }
    }
    .banner_box {
      aspect-ratio: 335 / 540;
      @include md {
        aspect-ratio: 756 / 480;

        // mdからlgの間で1枚の場合はaspect-ratio: unsetを適用
        &:only-child {
          aspect-ratio: unset;
        }
      }
    }
  }
  .popular_products_section {
    contain-intrinsic-width: auto 820px;
    background-color: $primary-10;
    .popular_products_wrapper {
      @include container-lg;
      padding: 3.75rem 0;
      @include md {
        padding: 5rem 3rem;
      }
      @include lg {
        padding: 6.25rem 5rem;
      }
    }
  }
  .popular_products_wrapper,
  .product_list_wrapper {
    @include container-lg;
    padding: 0;
    @include md {
      padding: 0 3rem;
    }
    @include lg {
      padding: 0 5rem;
    }
    .product_list_header {
      padding: 0 1.25rem;
      margin-bottom: 1.5rem;
      @include md {
        padding: 0;
      }
    }
    .product_lists {
      padding: 0 0 0 1.25rem;
      @include md {
        padding: 0;
      }
    }
  }
  .bakune_section,
  .comfort_tech_wear_section,
  .bedding_section,
  .sandal_section {
    display: flex;
    contain-intrinsic-size: auto 1500px;
    flex-direction: column;
    gap: 2.5rem;
    margin-bottom: 3.75rem;
    @include md {
      gap: 3.75rem;
      margin-bottom: 6.25rem;
    }
    .product_list_wrapper {
      margin: 0 auto;
    }
  }
  .category_section {
    @include container-lg;
    contain-intrinsic-size: auto 730px;
    padding: 3.75rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    @include md {
      padding: 5rem 3rem;
      gap: 2rem;
    }
    @include lg {
      padding: 6.25rem 5rem;
    }
    .category_list_wrapper {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 1rem 0.5rem;
      @include md {
        grid-template-columns: repeat(auto-fill, minmax(106px, 1fr));
        gap: 2.5rem;
      }
      .category_list {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.25rem;
        .category_name {
          font-size: $font-size-12;
          text-align: center;
          white-space: pre-line;
        }
        .img {
          aspect-ratio: 1 / 1;
          border-radius: 50%;
          object-fit: cover;
          border: 1px solid $black-10;
        }
      }
    }
  }
  .sandal_section {
    margin-bottom: 0;
  }
}
</style>
